import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Works from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import Stars from "@/pages/stars/page";
import StarDetail from "@/pages/stars/detail/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "works",
        element: <Works />,
      },
      {
        path: "works/:id",
        element: <WorkDetail />,
      },
      {
        path: "stars",
        element: <Stars />,
      },
      {
        path: "stars/:id",
        element: <StarDetail />,
      },
      {
        path: "news",
        element: <NewsList />,
      },
      {
        path: "news/:id",
        element: <NewsDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;